import reducer, { initialState, ClientBookingContextActions, ClientBookingContextState } from './reducer';
import React, { createContext, Dispatch, useReducer } from 'react';
import { FCWithChildren } from '../../../../utils/utils.types';

export const ClientBookingContext = createContext<ClientBookingContextState | null>(null);
export const ClientBookingDispatchContext = createContext<Dispatch<ClientBookingContextActions> | null>(null);
export const ClientBookingProvider: FCWithChildren = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <ClientBookingContext.Provider value={state}>
            <ClientBookingDispatchContext.Provider value={dispatch}>{children}</ClientBookingDispatchContext.Provider>
        </ClientBookingContext.Provider>
    );
};
